module.exports = __webpack_public_path__ + "fonts/TBCSailec-Medium.42e1241a.ttf";